import { SR_API_ACTION_JOB_ORDER_UPDATE_STATUS } from 'api/actionTypes';

export default async function updateJobOrderStatus({ state, apiClient }, { jobOrderId, status }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_JOB_ORDER_UPDATE_STATUS,
    state: state,
    payload: {
      jobOrderId,
      status,
    },
  });
}
